import React from "react";
import Footer from "../components/Footer";
import Navbar1 from "../components/Navbar1";

function Investment() {
  return (
    <div>
      <Navbar1 />

      {/* Hero Section */}
      <div className="container-fluid sect3bgimage text-center text-white py-5">
        <h1 className="display-4 fw-bold">Strategic Investments for a Secure Future</h1>
        <p className="lead px-4">
          Partner with KR Homes to capitalize on high-value real estate opportunities. Our expertise in real estate investment ensures
          sustainable growth, maximized returns, and secure assets for our investors. Join us in shaping the future of luxury real estate.
        </p>
      </div>

      {/* Investment Overview */}
      <div className="container my-5">
        <div className="row">
          <div className="col-lg-6 mb-4">
            <h2 className="fw-bold">Our Investment Approach</h2>
            <p className="px-3">
              At KR Homes, we specialize in identifying lucrative real estate investment opportunities that deliver long-term value.
              Our focus is on high-end residential projects with strong growth potential and sustainable returns. We conduct in-depth
              market research, analyze financial trends, and leverage industry insights to develop projects that enhance asset appreciation.
            </p>
          </div>
          <div className="col-lg-6">
            <h2 className="fw-bold">Proven Track Record</h2>
            <p className="px-3">
              Our past projects reflect our commitment to excellence, profitability, and investor satisfaction. We take pride in
              our ability to execute projects that provide high returns on investment while maintaining top-tier quality and luxury.
            </p>
            <ul className="list-group list-group-flush px-3">
              <li className="list-group-item">Suwanee Preserve – $40 Million Luxury Villas</li>
              <li className="list-group-item">Radhe Shaym Residential Complex – $25 Million</li>
              <li className="list-group-item">SRS Arkade – $10 Million</li>
            </ul>
          </div>
        </div>
      </div>



      <div className="">
              <img
                src={require("../images/whyinvest.jpg")}
                alt=""
                className="img-fluid"
              />
            </div>



      {/* Why Invest With Us? */}
      <div className="container-fluid bg-light py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">Why Invest with KR Homes?</h2>
          <div className="row">
            <div className="col-lg-4 text-center mb-4">
              <h4>High ROI</h4>
              <p className="px-3">
                Our projects consistently deliver strong returns, backed by market research and strategic planning. We focus on
                premium locations, ensuring high demand and stable value appreciation for your investments.
              </p>
            </div>
            <div className="col-lg-4 text-center mb-4">
              <h4>Expert Management</h4>
              <p className="px-3">
                Led by industry professionals with extensive experience in real estate investments and asset management,
                our team ensures seamless project execution, regulatory compliance, and optimal financial performance.
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <h4>Transparency</h4>
              <p className="px-3">
                We ensure full transparency in all transactions, with regular updates, investor reports, and clear financial disclosures.
                Your trust and confidence in our operations are our top priorities.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact for Investment Opportunities */}
      <div className="container text-center py-5">
        <h2 className="fw-bold">Explore Investment Opportunities</h2>
        <p className="px-3">
          Contact us today to discuss available investment opportunities and partnership options. Our team is ready to assist you
          with comprehensive market insights, project breakdowns, and customized investment strategies tailored to your goals.
        </p>
        <div className="mt-4">
          <h5>Yugandhar Kummathi</h5>
          <p>Phone: +1 904 4368696</p>
          <p>Email: <a href="mailto:info@kpnservicesllc.com">info@kpnservicesllc.com</a></p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Investment;